import { useLayoutStore } from '../layoutStore';
import { buildTabScopeKey } from './tab-scope-key';

export function getActiveTabScopeKey(targetId: string): string | undefined {
  const { activeMainContentTabId, tabNavigationByTabId } =
    useLayoutStore.getState();

  if (!activeMainContentTabId) {
    return undefined;
  }

  const navigation = tabNavigationByTabId[activeMainContentTabId];
  const activePageEntry = navigation?.entries[navigation.currentIndex];

  return buildTabScopeKey({
    targetId,
    tabId: activeMainContentTabId,
    pageKey: activePageEntry?.pageId ?? activeMainContentTabId,
  });
}
